<template>
  <div class="product">
    <product-banner type="fixed"></product-banner>
    <product-detail type="fixed"></product-detail>
  </div>
</template>

<script>
import ProductBanner from '@/components/product/ProductBanner'
import ProductDetail from '@/components/product/ProductDetail'

export default {
  components: {
    ProductBanner,
    ProductDetail,
  },
}
</script>
